// Browser-side Authentik login: Authorization Code + PKCE via oidc-client-ts.
// Configured by /config.json (see config.ts). With no authority there is no
// login and the API client sends no bearer — the API then refuses everything.
import { UserManager, WebStorageStateStore, type User } from "oidc-client-ts";
import { config } from "./config";

let manager: UserManager | null | undefined;

function mgr(): UserManager | null {
  if (manager !== undefined) return manager;
  const { oidcAuthority, oidcClientId } = config();
  manager = oidcAuthority && oidcClientId
    ? new UserManager({
        authority: oidcAuthority,
        client_id: oidcClientId,
        redirect_uri: `${location.origin}/callback`,
        post_logout_redirect_uri: `${location.origin}/`,
        response_type: "code",
        scope: "openid profile email groups",
        userStore: new WebStorageStateStore({ store: sessionStorage }),
        automaticSilentRenew: true,
      })
    : null;
  return manager;
}

export const authEnabled = (): boolean => mgr() !== null;

export async function currentUser(): Promise<User | null> {
  const m = mgr();
  if (!m) return null;
  if (location.pathname === "/callback") {
    const u = await m.signinCallback();
    history.replaceState(null, "", "/");
    return u ?? null;
  }
  const u = await m.getUser();
  return u && !u.expired ? u : null;
}
export function login(): Promise<void> { return mgr()?.signinRedirect() ?? Promise.resolve(); }
export function logout(): Promise<void> { return mgr()?.signoutRedirect() ?? Promise.resolve(); }
export async function getAccessToken(): Promise<string | null> {
  const m = mgr();
  if (!m) return null;
  const u = await m.getUser();
  return u && !u.expired ? u.access_token : null;
}
